import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { AuthAction } from '../../actions';
import { Translate as t } from '../../config/Translate';

const DeepSearchFilterSave = ({ showModal, callbackClose, type, callbackSave, filter, filterset, user, UpdateUserAdminFilters }) => {
	const [filters, setFilters] = useState([]);
	const [data, setData] = useState({
		type: type,
		title: "",
		description: "",
		filter: filter
	});

	useEffect(() => {
		setData({ ...data, type: type });
	}, [type]);

	useEffect(() => {
		setFilters(Array.isArray(user.filters) ? user.filters : []);
	}, [user.filters]);

	useEffect(() => {
		setData({ ...data, filter: filter });
	}, [filter]);

	useEffect(() => {
		setData(filterset);
	}, [filterset]);

	const btnSave = () => {
		let newfilters = [];
		const safeFilters = Array.isArray(filters) ? filters : [];
		if (filterset.id) {
			safeFilters.map(x => {
				newfilters.push((x.id == filterset.id ? data : x))
			})
		} else {
			newfilters = [...safeFilters, { ...data, type: type, id: new Date().valueOf() }]
		}
		UpdateUserAdminFilters({ filters: newfilters });
		callbackSave(data);
		callbackClose();
	}

	return (
		<Modal show={showModal} onHide={() => callbackClose(false)}>
			<Modal.Header>
				<h2 className="modal-title">{data.id ? "Update Filter" : "Add New Filter"}</h2>
			</Modal.Header>
			<Modal.Body className="p-0">
				<ul className="listview simple-listview no-space border-0 m-2">
					<div className="form-group basic">
						<div className="input-wrapper">
							<label className="label">FilterName</label>
							<input className="form-control"
								onChange={(e) => setData({ ...data, title: e.target.value })}
								defaultValue={data.title} />
						</div>
					</div>
					<div className="form-group basic">
						<div className="input-wrapper">
							<label className="label">Description</label>
							<textarea className="form-control"
								rows={5}
								onChange={(e) => setData({ ...data, title: e.target.value })}
								defaultValue={data.description}></textarea>
						</div>
					</div>
				</ul>
			</Modal.Body>
			<Modal.Footer>
				<button
					className={data.title != "" ? "btn btn-block btn-primary mb-0" : "btn btn-block btn-primary disabled mb-0"}
					onClick={() => { btnSave(data); }}>{t('common.button.saveFilter')}</button>
				<button className="btn btn-block btn-dark" onClick={() => callbackClose(false)}>{t('common.button.cancel')}</button>
			</Modal.Footer>
		</Modal>
	);
}

const mapState = (state) => {
	const user = state.AuthReducer.user;
	return { user };
};

const mapDispatch = (dispatch) => ({
	UpdateUserAdminFilters: (uinfo) => dispatch(AuthAction.UpdateUserAdminFilters(uinfo)),
});

export default connect(mapState, mapDispatch)(DeepSearchFilterSave);